import React from 'react';
import { ReactComponent as TipsIcon } from 'assets/images/tips.svg';
import { ReactComponent as ComplainIcon } from 'assets/images/complain.svg';

export enum ESearchParams {
  UserId = 'uniqid',
  OrganizationId = 'id_org',
  TransactionId = 'tuid',
  UUID = 'uuid',
  VisitorUid = 'visitor_uid',
  Review = 'review',
  /** Источник перехода внутри страницы: ставит только сама страница при переходах; адрес без него -
   *  адрес носителя или возврата бэка (metrika-landing, R-2, R-3). */
  Source = 'source',
  /** Метка носителя: источник перехода для воронки Метрики (metrika-landing, R-1). */
  UtmSource = 'utm_source',
}

/** Префикс меток носителя (utm_source, utm_medium, utm_campaign и прочие): во внутренние адреса страницы
 *  они не переходят (metrika-landing, R-2). */
export const UTM_PREFIX = 'utm_';

export enum ELayoutType {
  Payment = 'payment',
  Success = 'success',
  Fail = 'fail',
}

export enum EPaymentTab {
  Tips = 'tips',
  Complain = 'complain',
}

export enum EStorageKey {
  ClientId = 'clientId',
  /** Токен и флаг сохранённой карты: карта больше не сохраняется (payment-buttons, R-9),
   *  ключи только удаляются со страницы оплаты. */
  PayspotToken = 'payspot_token',
  SaveCard = 'save_card',
  Lang = 'lang',
  /** Старые контакты гостя (name, surname, city, email): только читаются для миграции и удаляются
   *  после успешной оплаты; контакты теперь хранит кука API (payer-form, R-5). */
  Name = 'name',
  Surname = 'surname',
  City = 'city',
  Email = 'email',
  /** Страна последней открытой на устройстве страницы со страной (US-034, R-3). */
  Country = 'country',
  /** Отметка «язык выбрал гость»: ставит только нажатие в переключателе (US-034, R-2). */
  LangChosen = 'lang_chosen',
  /** Снимок параметров воронки последней начатой на устройстве попытки (metrika-funnel, R-5). */
  MetrikaCheckout = 'metrika_checkout',
  /** Платежи, по которым завершение с устройства уже отправлено, за 30 дней (metrika-funnel, R-5). */
  MetrikaCompleted = 'metrika_completed',
}

/** Способ оплаты по нажатой кнопке, поле payment_method запроса start: страница сообщает, чем платит
 *  гость, маршрут выбирает бэк (payment-method-rename, R-1, R-7). */
export enum EPaymentMethod {
  Card = 'card',
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
}

/** Бренд кнопки Apple Pay / Google Pay по устройству гостя (payment-buttons, R-1; payment-method-rename, R-7). */
export enum EPayBrand {
  ApplePay = 'apple_pay',
  GooglePay = 'google_pay',
}

/** Страна организации из ответа recipient_info (контракт US-023, B1). */
export enum ECountry {
  RS = 'RS',
  ME = 'ME',
}

export enum EYandexMetrikaEvent {
  ClickTipValue = 'clickTipValue',
  SetRatingStar = 'setRatingStar',
  CheckboxCode289 = 'checkboxCode289',
  ClickPaymentButton = 'clickPaymentButton',
  LikeButtonClick = 'likeButtonClick',
  DislikeButtonClick = 'dislikeButtonClick',
  LikeAndTipButtonClick = 'likeAndTipButtonClick',
  /** Воронка (metrika-funnel, metrika-landing; docs/system/payment-page-analytics.md). */
  LandingOpened = 'landingOpened',
  ReviewOpened = 'reviewOpened',
  CheckoutOpened = 'checkoutOpened',
  TipAmountSelected = 'tipAmountSelected',
  CommissionToggleClicked = 'commissionToggleClicked',
  PaymentStarted = 'paymentStarted',
  PaymentCompleted = 'paymentCompleted',
}

/** Источник перехода: значение utm_source адреса носителя (или внутреннего source); иное и отсутствие -
 *  unknown (metrika-landing, R-1). */
export enum EFunnelSource {
  NfcCube = 'nfc_cube',
  QrCode = 'qr_code',
  Unknown = 'unknown',
}

/** Тип входа в landingOpened (metrika-landing, R-3). */
export enum EEntryType {
  /** Адрес заведения, показан список официантов, в том числе пустой. */
  EmployeeList = 'employee_list',
  /** Адрес заведения с единственным официантом: страница сама открывает его форму. */
  AutoEmployee = 'auto_employee',
  /** Адрес официанта. */
  DirectEmployee = 'direct_employee',
}

/** Тип флоу по экрану оценки заведения (review_subscription, O-6). */
export enum EFlowType {
  TipsOnly = 'tips_only',
  TipsReview = 'tips_review',
}

/** Экран оценки: заведения (список официантов) или официанта (R-12). */
export enum EReviewTarget {
  Organization = 'organization',
  Waiter = 'waiter',
}

/** Версия формы чаевых в событиях воронки (O-1). */
export const CHECKOUT_VERSION = 'simplified_v1';

export enum EEventAction {
  Like = 'like',
  Dislike = 'dislike',
  LikeAndTips = 'likeandtips',
  Pay = 'pay',
}

/* Канонические пути экранов (web-hosts.md, pay-host R-1). Старые пути с префиксом /client открывают те же
 *  экраны: префикс открытого адреса - basename маршрутизатора (helpers/router.helper.ts). */
export enum ERoute {
  WaiterList = '/choosing_waiter',
  Payment = '/payment',
  Success = '/success',
  Fail = '/payment_error',
}

export const paymentTabs = [
  {
    id: EPaymentTab.Tips,
    label: 'payment.tips.tips',
    icon: <TipsIcon />,
  },
  {
    id: EPaymentTab.Complain,
    label: 'payment.complain.complain',
    icon: <ComplainIcon />,
  },
];

export const ratingValues = [1, 2, 3, 4, 5];

export enum ELanguage {
  EN = 'en',
  SR = 'sr',
  ES = 'es',
  /** Черногорский: код ISO 639-2/3, как на терминале (US-032). */
  CNR = 'cnr',
}
